import { render, staticRenderFns } from "./BlouseProductCard.vue?vue&type=template&id=3f80b847&"
import script from "./BlouseProductCard.vue?vue&type=script&lang=js&"
export * from "./BlouseProductCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports